import script from "./QueryTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./QueryTable.vue?vue&type=script&setup=true&lang=ts"

import "./QueryTable.vue?vue&type=style&index=0&id=0dcd3845&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dcd3845"]])

export default __exports__